<div class="nova-feedback" *ngIf="responseId">
  <div class="nova-feedback__vote" *ngIf="!submitted">
    <button
      type="button"
      class="nova-feedback__btn"
      [class.nova-feedback__btn--active]="voted === true"
      [attr.aria-label]="'AI_FEEDBACK_THUMBS_UP' | translate"
      [attr.aria-pressed]="voted === true"
      (click)="downPopover.dismiss(null, 'switch'); vote(true)">
      <ion-icon [name]="voted === true ? 'thumbs-up' : 'thumbs-up-outline'" aria-hidden="true"></ion-icon>
    </button>
    <button
      type="button"
      class="nova-feedback__btn"
      [class.nova-feedback__btn--active]="voted === false"
      [attr.aria-label]="'AI_FEEDBACK_THUMBS_DOWN' | translate"
      [attr.aria-pressed]="voted === false"
      (click)="vote(false); downPopover.present($event)">
      <ion-icon [name]="voted === false ? 'thumbs-down' : 'thumbs-down-outline'" aria-hidden="true"></ion-icon>
    </button>
  </div>
  <span class="nova-feedback__thanks" *ngIf="submitted">{{ 'AI_FEEDBACK_THANKS' | translate }}</span>
  <span class="nova-feedback__usage" *ngIf="tokenLabel" [attr.title]="tokenTitle">{{ tokenLabel }}</span>
</div>

<!-- Reason popover — floats above content, anchored to the 👎 button; never reflows the card. -->
<ion-popover #downPopover class="nova-feedback-popover" (didDismiss)="onPopoverDismiss($event)">
  <ng-template>
    <div class="nova-feedback__comment">
      <input
        class="nova-feedback__comment-input"
        type="text"
        [(ngModel)]="comment"
        name="feedbackComment"
        [placeholder]="'AI_FEEDBACK_REASON_PLACEHOLDER' | translate"
        autocomplete="off"
        (keyup.enter)="downPopover.dismiss(null, 'confirm')"
        (keyup.escape)="downPopover.dismiss(null, 'cancel')" />
      <button
        type="button"
        class="nova-feedback__comment-btn"
        [attr.aria-label]="'CONFIRM' | translate"
        [title]="'CONFIRM' | translate"
        (click)="downPopover.dismiss(null, 'confirm')">
        <ion-icon name="checkmark-outline" aria-hidden="true"></ion-icon>
      </button>
      <button
        type="button"
        class="nova-feedback__comment-btn"
        [attr.aria-label]="'CANCEL' | translate"
        [title]="'CANCEL' | translate"
        (click)="downPopover.dismiss(null, 'cancel')">
        <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
      </button>
    </div>
  </ng-template>
</ion-popover>
